import { render, staticRenderFns } from "./TreeMarker.vue?vue&type=template&id=06b94827&"
import script from "./TreeMarker.vue?vue&type=script&lang=ts&"
export * from "./TreeMarker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports